import { automationFullFragment } from './fragments';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const automationPauseAtom = createMutationAtomFactory(
  'automations.pause',
  (params: { id: string }) => ({
    automationsAutomationPause: {
      __args: {
        id: params.id,
      },
      ...automationFullFragment,
    },
  }),
);
